<div class="position-relative">
  <div
    mat-dialog-title
    class="dialog-title mb-1 d-flex justify-content-end align-items-end">
    <button mat-icon-button aria-label="close dialog" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content [ngClass]="isMobile ? 'max-h-mobile' : ''">
    <div class="kycApt-popup-desktop" *ngIf="!isMobile">
      <img
        class="d-inline-block align-top"
        src="/assets/CRI/kyc/kyc-update-info-desktop.png"
        alt="kyc-img" />
      <div style="text-align: center !important; padding-top: 10px">
        <button
          mat-dialog-close
          class="btn btn-secondary btn-block w-auto mx-auto alert-completeKycBtn"
          type="button"
          [routerLink]="['/app/profile']"
          [queryParams]="{ completeKyc: true }">
          {{ 'withdraw.completeInformation' | translate }}
        </button>
      </div>
    </div>

    <div class="kycApt-popup-mobile" *ngIf="isMobile">
      <img
        class="d-inline-block align-top"
        src="/assets/CRI/prepaid/kipo-pop-up-mobile.svg"
        alt="kyc-img" />

      <button
        mat-dialog-close
        class="btn btn-secondary btn-block w-auto mx-auto alert-completeKycBtn"
        type="button"
        [routerLink]="['/app/profile']"
        [queryParams]="{ completeKyc: true }">
        {{ 'withdraw.completeInformation' | translate }}
      </button>
    </div>
  </mat-dialog-content>
</div>
